import { createFileRoute } from '@tanstack/react-router'
import { ClubPage } from '~/features/club/ClubPage'
import { clubQuery } from '~/features/club/queries'
import { Gate, RouteError } from '~/features/operations/shared'
import { loaderScope } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/')({
  loader: async ({ context }) => {
    const scope = await loaderScope(context.queryClient)
    if (scope.permissions.includes('ops.read')) await context.queryClient.ensureQueryData(clubQuery(scope.organizationId)).catch(() => undefined)
  },
  component: () => (
    <Gate permission="ops.read">
      <ClubPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
